import {
  DevicesService,
  GetDevice_GetDeviceResponse,
  ReadSensorCoords_ReadSensorCoordsResponse,
  ReadSensorParams_ReadSensorParamsResponse,
  ReadSensorGpsTime_ReadSensorGpsTimeResponse,
  SensorBlockService,
} from "../api";

export const SensorBlockApi = {

  // Получение параметров датчика
  getSensorBlockParams: async (id: string): Promise<ReadSensorParams_ReadSensorParamsResponse> => {
    return SensorBlockService.getApiSensorBlockParams(id);
  },

  // Получение gps координат датчика
  getSensorBlockGpsCoordinates: async (id: string): Promise<ReadSensorCoords_ReadSensorCoordsResponse> => {
    return SensorBlockService.getApiSensorBlockGpsCoords(id);
  },

  // Получение gps времени датчика
  getSensorBlockGpsTime: async (id: string): Promise<ReadSensorGpsTime_ReadSensorGpsTimeResponse> => {
    return SensorBlockService.getApiSensorBlockGpsTime(id);
  },

  // Запись счетчиков удара и двери
  updateCounters: async (id: string, payload: any): Promise<boolean> => {
    await SensorBlockService.postApiSensorBlockCounters(id, {counters: payload});
    return true;
  },

  // Получение данных
  getSensorBlockData: async (id: string): Promise<GetDevice_GetDeviceResponse> => {
    return DevicesService.getApiDevices(id);
  },
}
